module.exports = __webpack_public_path__ + "static/media/superdry1.274e362b.jpg";